module.exports = __webpack_public_path__ + "static/img/partner_XVII.bb98342.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_XVII.png
// module id = kNN6
// module chunks = 9